import { render, staticRenderFns } from "./CampoDeClienteNoCaixa.vue?vue&type=template&id=776173ce&scoped=true&"
import script from "./CampoDeClienteNoCaixa.vue?vue&type=script&lang=ts&"
export * from "./CampoDeClienteNoCaixa.vue?vue&type=script&lang=ts&"
import style0 from "./CampoDeClienteNoCaixa.vue?vue&type=style&index=0&id=776173ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776173ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemTitle,VMenu})
